import { render, staticRenderFns } from "./button.vue?vue&type=template&id=f5097686"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5097686')) {
      api.createRecord('f5097686', component.options)
    } else {
      api.reload('f5097686', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=f5097686", function () {
      api.rerender('f5097686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/basic/button/src/button.vue"
export default component.exports